var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkillIconsInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skill-icons:instagram",
    clipPath: "url(#clip0_8_36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M57.4219 0H17.5781C7.86999 0 0 7.86999 0 17.5781V57.4219C0 67.13 7.86999 75 17.5781 75H57.4219C67.13 75 75 67.13 75 57.4219V17.5781C75 7.86999 67.13 0 57.4219 0Z",
    fill: "url(#paint0_radial_8_36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M57.4219 0H17.5781C7.86999 0 0 7.86999 0 17.5781V57.4219C0 67.13 7.86999 75 17.5781 75H57.4219C67.13 75 75 67.13 75 57.4219V17.5781C75 7.86999 67.13 0 57.4219 0Z",
    fill: "url(#paint1_radial_8_36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.5026 8.20312C29.5462 8.20312 28.5475 8.23799 25.4227 8.38008C22.3037 8.52305 20.1747 9.0167 18.312 9.74121C16.3849 10.4895 14.7504 11.4905 13.1221 13.1194C11.4923 14.748 10.4912 16.3825 9.74063 18.3088C9.01406 20.1721 8.51982 22.302 8.37949 25.4194C8.23975 28.5445 8.20312 29.5436 8.20312 37.5003C8.20312 45.457 8.23828 46.4525 8.38008 49.5773C8.52363 52.6963 9.01729 54.8253 9.74121 56.688C10.49 58.6151 11.4911 60.2496 13.12 61.8779C14.748 63.5077 16.3825 64.5111 18.3082 65.2594C20.1724 65.9839 22.3017 66.4775 25.42 66.6205C28.5451 66.7626 29.543 66.7975 37.4991 66.7975C45.4564 66.7975 46.452 66.7626 49.5768 66.6205C52.6957 66.4775 54.827 65.9839 56.6912 65.2594C58.6175 64.5111 60.2496 63.5077 61.8773 61.8779C63.5071 60.2496 64.5079 58.6151 65.2588 56.6889C65.9789 54.8253 66.4734 52.6957 66.6199 49.5779C66.7603 46.4531 66.7969 45.457 66.7969 37.5003C66.7969 29.5436 66.7603 28.5451 66.6199 25.42C66.4734 22.3011 65.9789 20.1724 65.2588 18.3097C64.5079 16.3825 63.5071 14.748 61.8773 13.1194C60.2478 11.4899 58.6181 10.4889 56.6895 9.7415C54.8218 9.0167 52.6916 8.52275 49.5727 8.38008C46.4476 8.23799 45.4526 8.20312 37.4936 8.20312H37.5026ZM34.8744 13.4827C35.6546 13.4815 36.525 13.4827 37.5026 13.4827C45.3252 13.4827 46.2521 13.5108 49.3412 13.6512C52.1977 13.7818 53.748 14.2591 54.7808 14.6602C56.148 15.191 57.1228 15.8259 58.1476 16.8516C59.173 17.877 59.8075 18.8534 60.3398 20.2207C60.7409 21.252 61.2188 22.8023 61.3488 25.6588C61.4892 28.7473 61.5196 29.6748 61.5196 37.4936C61.5196 45.3123 61.4892 46.2401 61.3488 49.3283C61.2182 52.1848 60.7409 53.7352 60.3398 54.7667C59.809 56.134 59.173 57.1075 58.1476 58.1323C57.1222 59.1577 56.1486 59.7923 54.7808 60.3234C53.7492 60.7263 52.1977 61.2023 49.3412 61.333C46.2527 61.4733 45.3252 61.5038 37.5026 61.5038C29.6798 61.5038 28.7525 61.4733 25.6644 61.333C22.8079 61.2012 21.2575 60.7239 20.2239 60.3228C18.8569 59.7917 17.8802 59.1571 16.8548 58.1317C15.8294 57.1063 15.1948 56.1322 14.6625 54.7644C14.2614 53.7328 13.7836 52.1824 13.6535 49.326C13.5132 46.2375 13.4851 45.31 13.4851 37.4862C13.4851 29.6628 13.5132 28.7399 13.6535 25.6515C13.7842 22.795 14.2614 21.2446 14.6625 20.2119C15.1937 18.8446 15.8294 17.8682 16.8551 16.8428C17.8805 15.8174 18.8569 15.1825 20.2242 14.6505C21.2569 14.2477 22.8079 13.7716 25.6644 13.6403C28.367 13.5182 29.4144 13.4815 34.8744 13.4754V13.4827ZM53.1413 18.3472C51.2004 18.3472 49.6257 19.9204 49.6257 21.8616C49.6257 23.8025 51.2004 25.3772 53.1413 25.3772C55.0822 25.3772 56.6569 23.8025 56.6569 21.8616C56.6569 19.9207 55.0822 18.346 53.1413 18.346V18.3472ZM37.5026 22.4549C29.194 22.4549 22.4575 29.1914 22.4575 37.5003C22.4575 45.8092 29.194 52.5425 37.5026 52.5425C45.8115 52.5425 52.5457 45.8092 52.5457 37.5003C52.5457 29.1917 45.8109 22.4549 37.5021 22.4549H37.5026ZM37.5026 27.7345C42.8959 27.7345 47.2685 32.1064 47.2685 37.5003C47.2685 42.8936 42.8959 47.2661 37.5026 47.2661C32.1091 47.2661 27.7371 42.8936 27.7371 37.5003C27.7371 32.1064 32.1091 27.7345 37.5026 27.7345Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8_36",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.9219 80.7765) rotate(-90) scale(74.3306 69.1333)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8_36",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-12.5628 5.40264) rotate(78.681) scale(33.2262 136.959)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillIconsInstagram);
export default __webpack_public_path__ + "static/media/skill-icons-instagram.92bd34690ac35be28e81ec38cd308f95.svg";
export { ForwardRef as ReactComponent };